// extracted by mini-css-extract-plugin
export var btn = "styles-module--btn--x8RFI";
export var btnGroup = "styles-module--btnGroup--vbE-K";
export var columns = "styles-module--columns--xgep5";
export var container = "styles-module--container--wAs+O";
export var text = "styles-module--text--S7jHr";
export var textWrapper = "styles-module--textWrapper--xNgLI";